import { Fragment } from 'react'
import { Dialog, Scrim, Progress } from '@equinor/eds-core-react'
import { InteractionStatus } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import styled from 'styled-components'

const { CustomContent } = Dialog

const Unauthorized = () => {
    const { inProgress } = useMsal()

    return (
        <Fragment>
            {inProgress === InteractionStatus.None && (
                <Scrim isDismissable={false} open={true}>
                    <WideDialog open={true}>
                        <CustomContent>
                            <Container>
                                <Progress.Star />
                            </Container>
                        </CustomContent>
                    </WideDialog>
                </Scrim>
            )}
        </Fragment>
    )
}

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100%;
    height: 100%;
`

const WideDialog = styled(Dialog)`
    width: 450px;
`

export default Unauthorized
